<template>
  <v-card class="elevation-4 pa-4">
    <v-card-text class="pa-2">
      <h2 class="mb-3 font-weight-regular headline">Login</h2>
      <v-form class="pa-0">
        <v-text-field v-model="email"
                      label="E-mail"
                      required
        >
        </v-text-field>
        <v-text-field v-model="password"
                      label="Senha"
                      type="password"
                      required
        >
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-layout row wrap align-center
                :column="$vuetify.breakpoint.xsOnly"
      >
        <v-btn large color="primary" @click="submit">Acessar</v-btn>
        <v-spacer></v-spacer>
        <router-link :class="{'mt-4': $vuetify.breakpoint.xsOnly}"
                     :to="{ name: 'password_reset_path' }">
          Esqueceu a senha?
        </router-link>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    email: '',
    password: '',
    formError: false,
    alert: {
      text: '',
      show: false,
      type: ''
    }
  }),

  methods: {
    submit () {
      // this.axios.post('/users/sessions', { email: this.email, password: this.password })
      //   .then(response => this.signinSuccessful(response))
      //   .catch(error => this.signinFailed(error))
      this.formError = true
    },

    signinSuccessful () {

    },

    signinFailed (error) {
      this.alert.text = error
      this.alert.type = 'error'
      this.alert.show = true
    }
  }
}
</script>

<style>
</style>
